var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastpageicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.64044e-07 20.23L1.80459 22L12 12L1.80459 2L2.64044e-07 3.77L8.39082 12L2.64044e-07 20.23Z",
    fill: "#206BB1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.23L13.8046 22L24 12L13.8046 2L12 3.77L20.3908 12L12 20.23Z",
    fill: "#206BB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastpageicon);
export default __webpack_public_path__ + "static/media/lastpageicon.3051b51bb75f08f4268dad728fa3fdbc.svg";
export { ForwardRef as ReactComponent };